import { DocumentsType } from "v2-types/order";
import { AssociationType, DocumentFile } from "../types";

export const orderDocumentsAlphabetically = (documents: DocumentsType[]) => {
  return documents.sort((documentA, documentB) => {
    const documentDescriptionA = documentA.description.toLowerCase();
    const documentDescriptionB = documentB.description.toLowerCase();

    if (documentDescriptionA > documentDescriptionB) return 1;
    if (documentDescriptionA < documentDescriptionB) return -1;
    return 0;
  });
};

export const orderDocumentsFilesAlphabetically = (documents: DocumentFile[]) => {
  return documents.sort((documentA, documentB) => {
    const documentDescriptionA = documentA.description.toLowerCase();
    const documentDescriptionB = documentB.description.toLowerCase();

    if (documentDescriptionA > documentDescriptionB) return 1;
    if (documentDescriptionA < documentDescriptionB) return -1;
    return 0;
  });
};

export const orderPartiesAlphabetically = (parties: AssociationType[]) => {
  return parties.sort((a, b) => {
    const nameA = a.name.toLowerCase();
    const nameB = b.name.toLowerCase();

    if (nameA > nameB) return 1;
    if (nameA < nameB) return -1;
    return 0;
  });
};